import React, { useContext } from 'react';
import './ContactInfo.module.scss';
import Button from 'components/UI/Button';
import {
    faArrowLeft,
    faArrowRightToLine,
} from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tippy';
import { QuizContext } from 'screens/Quiz/Quiz';
import { faBarChart } from '@fortawesome/pro-solid-svg-icons';
import { TextAreaInput, TextInput } from 'components/UI/Form/Input';
import { useDispatch } from 'react-redux';
import sendQuiz from 'actions/mail/quiz';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ContactInfo() {
    const {
        setQuestionIndex,
        email,
        setEmail,
        phone,
        setPhone,
        answers,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        description,
        setDescription,
    } = useContext(QuizContext);

    const dispatch = useDispatch();

    return (
        <div styleName="contact-info">
            <div styleName="top">
                <div styleName="image-wrapper">
                    <img src="/images/laura.png" alt="Laura Romme" />
                </div>
                <h2>Ik help je graag verder!</h2>
                <p>
                    Hoi! Ik ben <span>Laura Romme</span>, begeleider van het
                    overstaptraject
                    {answers?.question1 !== 'Weet ik nog niet' && (
                        <>
                            {' '}
                            voor{' '}
                            <span styleName="uppercase">
                                {answers?.question1}
                            </span>
                        </>
                    )}
                    . Ik heb alvast wat informatie voor je verzameld. Deze vind
                    je op de volgende pagina. Eventueel kun je jouw mailadres
                    invullen. Kies je voor ‘overslaan’ dan kun je toch de
                    resultaten bekijken.
                </p>
                <div styleName="inputs-wrapper">
                    <TextInput
                        onChange={(e) => setFirstName(e.target.value)}
                        value={firstName}
                        type="text"
                        label="Voornaam"
                        placeholder="John"
                    />
                    <TextInput
                        onChange={(e) => setLastName(e.target.value)}
                        value={lastName}
                        type="text"
                        label="Achternaam"
                        placeholder="Doe"
                    />
                    <TextInput
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        type="email"
                        label="E-mailadres"
                        placeholder="voorbeeld@mail.com"
                    />
                    <TextInput
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                        type="tel"
                        label="Telefoonnummer"
                        placeholder="06 4392 3829"
                    />
                    <TextAreaInput
                        onChange={(e) => setDescription(e.target.value)}
                        value={description}
                        type="text"
                        label="Waar wil je het over hebben met het adviesgesprek?"
                        placeholder="Beschrijving"
                    />
                </div>
            </div>
            <div styleName="bottom-buttons">
                <Button
                    color="blue-gray"
                    onClick={() => setQuestionIndex((prev) => prev - 1)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Vorige
                </Button>
                <Tooltip
                    style={{ width: 'fit-content' }}
                    title="Door over te slaan kan je de resultaten bekijken maar kunnen wij je niet verder begeleiden."
                >
                    <Button
                        onClick={() => {
                            setQuestionIndex((prev) => prev + 1);
                            setEmail('');
                        }}
                        color="blue-gray"
                        icon={faArrowRightToLine}
                    >
                        Overslaan
                    </Button>
                </Tooltip>
                <Tooltip
                    disabled={email.length !== 0 && phone.length !== 0}
                    style={{ width: 'fit-content' }}
                    title="De velden moeten nog worden ingevuld"
                >
                    <Button
                        disabled={!email.length || !phone.length}
                        onClick={() => {
                            setQuestionIndex((prev) => prev + 1);
                            dispatch(
                                sendQuiz({
                                    answers,
                                    phone,
                                    email,
                                    firstName,
                                    lastName,
                                    description,
                                })
                            );
                        }}
                        color="blue"
                        icon={faBarChart}
                    >
                        Doorgaan
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}
